var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',[_c('td',[_c('jqxPivotDesigner',{ref:"pivotDesigner",staticStyle:{"width":"250px","height":"400px"},attrs:{"type":'pivotGrid'}})],1),_c('td',[_c('JqxPivotGrid',{ref:"pivotGrid",staticStyle:{"height":"400px"},attrs:{"autoResize":true,"source":_vm.pivotDataSource,"treeStyleRows":false,"multipleSelectionEnabled":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }